module.exports = __webpack_public_path__ + "5c0938c6c66aaa32525e0e0e7243c1f1.jpg";